import { AlphaNBoxIcon } from './AlphaNBoxIcon';

/**
 * author: GreenTurtwig
 * id 8A547BE1-B4F5-4080-824D-998618AF2542
 * name alpha-n-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-n-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterNBoxIcon = AlphaNBoxIcon;
export default LetterNBoxIcon